import { GuidePathsQuery, GuideQuery, GuideQueryVariables } from '@/graphql';
import GuideQueryDocument from '@/graphql/queries/Guide.gql';
import GuidePathsQueryDocument from '@/graphql/queries/GuidePaths.gql';
import MultiChapterGuide from '@/layouts/pages/MultiChapterGuidePage';
import GuideHTMLPage from '@/layouts/pages/guide/HTMLPage';
import { getPageProps } from '@/lib/craft-page';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps, notFoundResponse } from '@/lib/next';
import MasterTemplate from '@/templates/MasterTemplate';

const GuidePageHandler: PageTemplate<GuideQuery> = ({ entry }) => {
  if (!entry) return null;

  switch (entry.__typename) {
    case 'guides_guide_Entry':
      return <MultiChapterGuide entry={entry} />;
    case 'guides_htmlPage_Entry':
      return <GuideHTMLPage entry={entry} />;
    default:
      return null;
  }

};

GuidePageHandler.template = MasterTemplate;

export default GuidePageHandler;

export const getStaticProps = getStaticPageProps<{}, { slug: string[] }>(
  (params) => `guides/${params?.slug}`,
  async ({ client, uri }) => {

    const pageProps = await getPageProps<GuideQuery, GuideQueryVariables>({
      pathPrefix: '/guides',
      queryDocument: GuideQueryDocument,
      client,
      variables: {
        uri,
      },
    });

    if (pageProps?.entry) {
      return {
        props: {
          entry: pageProps.entry,
        },
      };
    }

    /* If all else fails, just 404 */
    return notFoundResponse;
  },
);

export const getStaticPaths = getStaticPagePaths('guides', async (context) => {
  const client = new CraftClient();

  const data = await client.request<GuidePathsQuery>(GuidePathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: path?.slug!,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});
